import React, { useEffect, useState } from 'react'
import { CANDIDATE_NEAR_ME, Candidate_Near_ME_Wt, Count_Seekers,countNearby,getCountwithtoken } from '../../../Service/service'
// import { location_of_candidates } from './ProfileData'
import { getData, postData } from '../../../Service/ApiMethod'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
// import { UserContext } from '../../../App' 
// import { useContext } from 'react'

// import { useState } from 'react'
// import { ContactEmergency } from '@mui/icons-material'
// import { useState } from 'react'



const Nearby = () => {
  // const user = useContext(UserContext);

  // console.log(user, "usweer")


  const [categories, setCategories] = useState();
  const [candidateNearMe, setCandidateNearMe] = useState([]);
  const [countnearme, setCountnearme] = useState({})
  // const [latitude, setLatitude] = useState('')
  // const [longitude, setLongitude] = useState('')
  // const [update, setUpdate] = useState(true)


  // useEffect(() => {
  //   var latitude = localStorage.getItem('lat');
  //   var longitude = localStorage.getItem('lng');
  //   setLatitude(latitude);
  //   setLongitude(longitude);
  // }, [update])


  const lng = localStorage.getItem('lng')
  const navigate = useNavigate();

  const getNearbycount =()=>{
    let request = {
      "latitude": localStorage?.getItem('lat'),
      "longitude": localStorage?.getItem('lng'),
    };
    // getData(Count_Seekers)
    postData(request,Count_Seekers)
      .then((response) => response.json())
      .then((res) => {
        setCountnearme(res.data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
      });
  }



  // const [distanceData, setDistanceData] = useState();
  const postCandidateNearMe = (distance) => {
    console.log("distance1000000", distance);

    const token = localStorage.getItem('catzapp_token');



    const obj = {
      radius: distance,
      "latitude": localStorage?.getItem('lat'),
      "longitude": localStorage?.getItem('lng'),

    }
    console.log("oksssssss000000000", obj);
    postData(obj, token !== null ? CANDIDATE_NEAR_ME : '')
      .then((response) => response.json())
      .then((data) => {
        console.log('nearby data', data)
        setCandidateNearMe(data?.data);
        // setUpdate(!update)
        navigate("/recommended-profiles", { state: { data, title: 'Candidates Near Me', distance: distance } })
      })
      .catch((err) => {
        console.log('Error', err);
      })
  }


  const getCategories = () => {
    let request = {
      "latitude": localStorage?.getItem('lat'),
      "longitude": localStorage?.getItem('lng'),
    };
    // getData(Count_Seekers)
    postData(request,Count_Seekers)
      .then((response) => response.json())
      .then((res) => {
        setCategories(res.data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
      });
  };
  console.log('categories', categories);

  const location_of_candidates = [
    {

      distance: 5,
      available_candidates: categories?.count_of_candidates_in_radius_5KMs,
    },
    {
      distance: 10,
      available_candidates: categories?.count_of_candidates_in_radius_10KMs,
    },
    {
      distance: 20,
      available_candidates: categories?.count_of_candidates_in_radius_20KMs,
    },
    {
      distance: 40,
      available_candidates: categories?.count_of_candidates_in_radius_40KMs,
    },
    {
      distance: 60,
      available_candidates: categories?.count_of_candidates_in_radius_60KMs,
    },
    {
      distance: 80,
      available_candidates: categories?.count_of_candidates_in_radius_80KMs,
    }, {
      distance: 100,
      available_candidates: categories?.count_of_candidates_in_radius_100KMs
      ,
    },
    {
      distance: 120,
      available_candidates: categories?.count_of_candidates_in_radius_120KMs,
    },
  ];

  console.log('location_of_candidates', location_of_candidates[0]?.available_candidates)

  useEffect(() => {
    getCategories();
    getNearbycount()
  }, [])
  useEffect(() => {
    getCategories();
    getNearbycount()
    // console.log(user, "useer")
  }, [])

  useEffect(() => {
    getCategories();
    getNearbycount()
  }, [lng])


  //   useEffect(() => {
  //  setCategories(categories)
  //   }, [])

  const { t } = useTranslation();
  return (
    location_of_candidates?.map((item, index) => {
      return (
        <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
          <div style={{ cursor: 'pointer' }} id={item?.distance} className="nearMe-box" onClick={(e) => {
            postCandidateNearMe(item?.distance);
          }}>
            <div className="row">
              <div className="col-2 px-0">
                <div className="location-img flex-center">
                  <img
                    src="./images/location.png"
                    alt=""
                    className="location-icon"
                    style={{width:25}}
                  />
                </div>
              </div>
              <div className="col-9 pr-0">
                <h2 className="location-heading">
                  {t('Within')} <span>
                    {item?.distance} KM {t('radius')}
                  </span>
                </h2>
                <p className="text">
                {item?.distance == 5 ? countnearme.count_of_candidates_in_radius_5KMs:item?.distance == 10?countnearme.count_of_candidates_in_radius_10KMs:item?.distance == 20?countnearme.count_of_candidates_in_radius_20KMs:item?.distance == 40?countnearme.count_of_candidates_in_radius_40KMs:item?.distance == 60?countnearme.count_of_candidates_in_radius_60KMs:item?.distance == 80?countnearme.count_of_candidates_in_radius_80KMs:item?.distance == 100?countnearme.count_of_candidates_in_radius_100KMs:item?.distance == 120?countnearme.count_of_candidates_in_radius_120KMs:0} {t('Candidates')}</p>
              </div>
              <div className="col-1 px-0 flex-center">
                <img src="./images/go-arrow.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      )
    })
  )
}

//<profileData data={console}/>

export default Nearby
